function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.9,13.4l7.8-7.8c1.6-1.6,3.2-3.2,4.8-4.8c0.6-0.8,1.7-0.9,2.5-0.3c0.1,0.1,0.2,0.2,0.3,0.3c1.2,1.2,2.4,2.4,3.6,3.6 c0.8,0.6,0.9,1.7,0.3,2.5C39.2,6.9,39.1,7,39,7.1L21.2,24.8c-0.5,0.8-1.6,1-2.3,0.5c-0.2-0.1-0.3-0.3-0.5-0.5 C12.5,18.9,6.6,13,0.7,7.1c-0.8-0.6-0.9-1.7-0.3-2.4c0.1-0.1,0.2-0.2,0.3-0.3C1.9,3.1,3,2,4.2,0.8s2-1,3,0c4,3.9,7.9,7.9,11.9,11.9 C19.3,12.9,19.6,13.1,19.9,13.4z"
});

var SvgChevronDown = function SvgChevronDown(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 39.7 25.5",
    style: {
      enableBackground: "new 0 0 39.7 25.5"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronDown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-down.977c7814.svg";
export { ForwardRef as ReactComponent };